export interface RequestsResetActionType {
  type: '@requests/RESET';
}

export const resetRequests = (): RequestsResetActionType => ({
  type: '@requests/RESET',
});
